{
  "title": "Grupa RW",
  "subtitle": "Sign in to your account",
  "form": {
    "email": "Email",
    "password": "Password",
    "submitIdle": "Sign in",
    "submitting": "Signing in..."
  },
  "errors": {
    "invalidCredentials": "Invalid email or password",
    "rateLimited": "Too many sign-in attempts. Try again later.",
    "unknown": "An error occurred. Try again."
  }
}
